import {
  lcmApiClient,
  // backendApiClient,
} from "lcm-iot-commons";

/* istanbul ignore next */
export async function resetTechnicalUserPassword(technicalUserId: $TSFixMe) {
  // @ts-expect-error TS(2554) FIXME: Expected 2-3 arguments, but got 1.
  return lcmApiClient().post(
    `/technical_users/${technicalUserId}/password_reset`,
  );
}

/* istanbul ignore next */
export async function deleteTechnicalUser(technicalUserId: $TSFixMe) {
  // @ts-expect-error TS(2554) FIXME: Expected 2-3 arguments, but got 1.
  return lcmApiClient().delete(`/technical_users/${technicalUserId}`);
}
